import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TimeCycleChart } from '@models';
import { environment } from 'environments/environment';
import { Observable, switchMap, timeout } from 'rxjs';

import { CommonFunctionsService } from '../common-functions/common-functions.service';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  private http: HttpClient = inject(HttpClient);
  private BASE_URL = environment.CRG_DIGITALIZATION_SERVICE_URL;
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);

  getTimeCycleData(studySk: string): Observable<TimeCycleChart> {
    const TIMEOUT = environment.KPI_CHART_DATA_TIMEOUT;
    const URL = `${this.BASE_URL}/v1/chart/time-cycle/${studySk}`;

    return this.commonFunctionsService
      .getRequestCommonParams(['org_ids', 'parent_client_names'])
      .pipe(
        switchMap(
          (params) =>
            this.http
              .get<TimeCycleChart>(URL, {
                withCredentials: true,
                params
              })
              .pipe(timeout(TIMEOUT)) as Observable<TimeCycleChart>
        )
      );
  }
}
